import { Card, Flex, Select, Typography } from "antd";
import React, { useState } from "react";

import ProcedureRowItem from "./ProcedureRowItem";

import arrowDown from "../../../../assets/icons/arrow-down.png";

const testFutureProcedures = [
  { procedureCode: 12345, procedureDescription: "Root Canal", appointments: 1000 },
  { procedureCode: 12345, procedureDescription: "Root Canal", appointments: 900 },
  { procedureCode: 12345, procedureDescription: "Root Canal", appointments: 800 },
  { procedureCode: 12345, procedureDescription: "Root Canal", appointments: 700 },
  { procedureCode: 12345, procedureDescription: "Root Canal", appointments: 600 },
  { procedureCode: 12345, procedureDescription: "Root Canal", appointments: 500 },
];

export default function FutureProcedures({ futureProcedureCodes }) {
  const [isTopArrowDown, setIsTopArrowDown] = useState(true);
  const [isDurationArrowDown, setIsDurationDown] = useState(true);

  const topOptionProcedures = [
    { label: "Top 5", value: 5 },
    { label: "Top 10", value: 10 },
    { label: "Top 15", value: 15 },
  ];

  const durationOptionProcedures = [
    { label: "1 Week", value: "1-week" },
    { label: "1 Month", value: "1-month" },
    { label: "1 Year", value: "1-year" },
  ];

  return (
    <Card style={{ width: "100%" }}>
      <Flex vertical gap={20}>
        <Flex align="center" justify="space-between">
          <Typography.Title level={4} style={{ marginBottom: 0 }}>
            Future Procedures
          </Typography.Title>

          <Flex gap={10}>
            <Select
              options={topOptionProcedures}
              defaultValue={10}
              style={{ width: 104, display: "flex", alignItems: "center", color: "#6b43b5" }}
              suffixIcon={<img src={arrowDown} alt="arrow-down" style={{ width: 16, transform: `rotate(${isTopArrowDown ? "0" : "180deg"})` }} />}
              className="custom-style-selection-top-performed-procedures"
              onOpenChange={() => setIsTopArrowDown((down) => !down)}
            />

            <Select
              options={durationOptionProcedures}
              defaultValue="1-month"
              style={{ width: 104, display: "flex", alignItems: "center", color: "#6b43b5" }}
              suffixIcon={
                <img src={arrowDown} alt="arrow-down" style={{ width: 16, transform: `rotate(${isDurationArrowDown ? "0" : "180deg"})` }} />
              }
              className="custom-style-selection-top-performed-procedures"
              onOpenChange={() => setIsDurationDown((down) => !down)}
            />
          </Flex>
        </Flex>

        <Flex vertical gap={10} style={{ height: 237, overflowY: "auto" }} className="custom-scroll">
          {testFutureProcedures.map((proceeure, index) => (
            <ProcedureRowItem index={index} procedure={proceeure} itemCount={proceeure.appointments} itemCountDescription="Appointments Booked" />
          ))}
        </Flex>
      </Flex>
    </Card>
  );
}
